import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { fmtGBP } from "@/lib/format";
import { Palette, Search, ArrowRight } from "lucide-react";
import FollowButton from "@/components/FollowButton";

export default function Artists() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { data = [] } = useQuery({
    queryKey: ["artists"],
    queryFn: async () => (await api.get("/artists")).data,
  });
  const filtered = q ? data.filter((a) => a.artist.toLowerCase().includes(q.toLowerCase())) : data;

  return (
    <div>
      <p className="text-[11px] font-mono uppercase tracking-widest text-amber-400/90">Market Coverage</p>
      <h1 className="font-serif text-3xl sm:text-4xl font-semibold tracking-tight flex items-center gap-3">
        <Palette className="w-7 h-7 text-amber-400" /> Artists
      </h1>

      <div className="relative mt-6 max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-3 text-slate-500" />
        <input data-testid="artist-search-input" className="al-input pl-9" placeholder="Search artists…" value={q} onChange={(e) => setQ(e.target.value)} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-6">
        {filtered.map((a) => (
          <div key={a.artist_canonical_id} data-testid={`artist-card-${a.artist_canonical_id}`}
            onClick={() => navigate(`/artists/${a.artist_canonical_id}`)}
            className="al-card p-5 text-left hover:border-amber-500/40 transition-colors group cursor-pointer">
            <div className="flex items-start justify-between">
              <h3 className="font-serif text-xl text-slate-100 group-hover:text-amber-400 transition-colors">{a.artist}</h3>
              <div className="flex items-center gap-2">
                <FollowButton cid={a.artist_canonical_id} name={a.artist} />
                <ArrowRight className="w-4 h-4 text-slate-600 group-hover:text-amber-400 transition-colors" />
              </div>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2 text-center">
              <div className="min-w-0"><p className="mono-num text-base sm:text-lg text-slate-200 truncate">{a.lots}</p><p className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Lots</p></div>
              <div className="min-w-0"><p className="mono-num text-base sm:text-lg text-emerald-400 truncate">{a.clearance_rate}%</p><p className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Clear</p></div>
              <div className="min-w-0"><p className="mono-num text-base sm:text-lg text-amber-400 truncate">{fmtGBP(a.turnover_gbp)}</p><p className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Turnover</p></div>
            </div>
            <div className="mt-3 flex flex-wrap gap-1">
              {a.houses.map((h) => <span key={h} className="al-chip border border-slate-700 text-slate-400">{h}</span>)}
            </div>
          </div>
        ))}
        {filtered.length === 0 && <div className="col-span-3 al-card p-16 text-center text-slate-500">No artists found.</div>}
      </div>
    </div>
  );
}
